import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// EN
import commonEN from 'src/latest/src/locales/common/en.json';
import insuranceVerificationEN from 'src/latest/src/components/InsuranceVerificationDetails/locales/en.json';
import resourcesEN from 'src/latest/src/features/resources/locales/en.json';
import therapistClientProfileModalsEN from 'src/containers/TherapistClientProfile/Tabs/onboarding/modals/locales/en.json';
import followUpToDoEN from 'src/latest/src/components/Todo/FollowUpTodo/locales/en.json';
import matchScoreConfirmationModalEN from 'src/latest/src/components/MatchScoreConfirmationModal/locales/en.json';
import componentsEN from 'src/latest/src/components/Locales/en.json';
import clinicianAvailabilityEN from 'src/containers/ClinitianAvailability/locales/en.json';
import profilesEN from 'src/latest/src/containers/TherapistProfile/locales/en.json';
import stripePaymentEN from 'src/containers/QuestionnaireParent/QuestionOptionsLibrary/components/StripePayment/locales/en.json';
import therapistUserSignUpEN from 'src/latest/src/features/therapist-user-signup/locales/en.json';
import accountEN from 'src/latest/src/features/account/locales/en.json';
import providerBenefitEN from 'src/containers/QuestionnaireParent/QuestionnairePages/ProviderBenefitPage/locales/en.json';
import intakeWelcomeScreenEN from 'src/containers/IntakeCompletionWelcomeScreen/locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    ns: [
      'common',
      'insuranceVerification',
      'resources',
      'therapistClientProfileModals',
      'followUpToDo',
      'matchScoreConfirmationModal',
      'sorting',
      'components',
      'profiles',
      'stripePayment',
      'therapistUserSignUp',
      'account',
      'providerBenefit',
      'intakeWelcomeScreen',
    ],
    resources: {
      en: {
        common: commonEN,
        insuranceVerification: insuranceVerificationEN,
        resources: resourcesEN,
        therapistClientProfileModals: therapistClientProfileModalsEN,
        followUpToDo: followUpToDoEN,
        matchScoreConfirmationModal: matchScoreConfirmationModalEN,
        components: componentsEN,
        clinicianAvailability: clinicianAvailabilityEN,
        profiles: profilesEN,
        stripePayment: stripePaymentEN,
        therapistUserSignUp: therapistUserSignUpEN,
        account: accountEN,
        providerBenefit: providerBenefitEN,
        intakeWelcomeScreen: intakeWelcomeScreenEN,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
